import React from 'react'
import { white } from '@consts/colors'
import classNames from 'classnames'
import styles from './styles.module.scss'

export type BadgeType = 'filled' | 'outline' | 'minimal'

export type BadgeProps = {
  classes?: string
  title?: string
  badgeType?: BadgeType
  themeColour?: string
  divergentBackground?: string
  small?: boolean
  smallX2?: boolean
  medium?: boolean
  fullWidth?: boolean
}

function Badge({
  classes = '',
  title,
  badgeType = 'filled',
  themeColour = '',
  small = false,
  smallX2 = false,
  medium = false,
  divergentBackground = '',
  fullWidth = false
}: BadgeProps) {
  const filled = {
    backgroundColor: divergentBackground || themeColour,
    color: divergentBackground ? themeColour : white,
    opacity: divergentBackground ? '90%' : '100%'
  }

  const outline = {
    backgroundColor: white,
    border: `1px solid ${themeColour}`,
    color: themeColour
  }

  const minimal = {
    backgroundColor: 'transparent',
    color: themeColour,
    height: 'auto',
    padding: 0,
    width: 'auto'
  }

  const badgeStyleTypes = {
    filled,
    outline,
    minimal
  }

  const propsToStyle = badgeStyleTypes[badgeType]
  const badgeClasses = classNames(`${styles.badge} ${classes}`, {
    [styles.badge_fullWidth]: fullWidth,
    [styles.badge_small]: small,
    [styles.badge_smallX2]: smallX2,
    [styles.badge_medium]: medium,
    [styles.badge_beta]: /beta/.test(classes),
    [styles.badge_minimal]: badgeType === 'minimal'
  })

  if (!title) {
    return null
  }

  return (
    <div className={badgeClasses} style={propsToStyle}>
      {title}
    </div>
  )
}

export default Badge
